import React, { useState, createContext, useContext } from 'react';
import { auth as authAPI, tokenManager } from '../services/api';
import pushService from '../services/pushService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [validatingToken, setValidatingToken] = useState(true);

  React.useEffect(() => {
    const validateToken = async () => {
      const token = tokenManager.get();
      const savedUser = localStorage.getItem('user');
      if (!token || !savedUser) { setValidatingToken(false); return; }
      try {
        const userData = await authAPI.me();
        const updatedUserData = {
          id: userData.id, email: userData.email, nome: userData.nome,
          tipo: userData.tipo, barbeiroId: userData.barbeiroId || null,
          barbeariaId: userData.barbeariaId || null,
          barbeariaSuspended: userData.barbeariaSuspended === true,
          trocarSenha: userData.primeiroAcesso === true
        };
        setUser(updatedUserData);
        localStorage.setItem('user', JSON.stringify(updatedUserData));
      } catch (err) {
        // Sem rede ou API em erro não invalida a sessão: só o 401 desloga
        if (err?.isAuthError || err?.response?.status === 401) {
          tokenManager.remove();
          setUser(null);
        }
      } finally {
        setValidatingToken(false);
      }
    };
    validateToken();
  }, []);

  const login = async (email, senha) => {
    try {
      setLoading(true);
      setError(null);
      const response = await authAPI.login(email, senha);
      tokenManager.save(response.token);
      const userData = {
        id: response.user.id, email: response.user.email, nome: response.user.nome,
        tipo: response.user.tipo, barbeiroId: response.user.barbeiroId || null,
        barbeariaId: response.user.barbeariaId || null,
        barbeariaSuspended: response.user.barbeariaSuspended === true,
        trocarSenha: response.user.primeiroAcesso === true
      };
      setUser(userData);
      localStorage.setItem('user', JSON.stringify(userData));
      try { await pushService.initialize(); } catch (pushError) {}
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || 'Erro ao fazer login');
      return false;
    }
  };

  const logout = async () => {
    try { await pushService.unregisterSubscription(); } catch (pushError) {}
    tokenManager.remove();
    setUser(null);
  };

  const concluirTrocaSenha = (token) => {
    if (token) tokenManager.save(token);
    const atualizado = { ...user, trocarSenha: false };
    setUser(atualizado);
    localStorage.setItem('user', JSON.stringify(atualizado));
  };

  React.useEffect(() => {
    const handleUnauthorized = () => { logout(); };
    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, error, validatingToken, concluirTrocaSenha }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
